/* eslint-disable import/extensions,import/no-unresolved,no-param-reassign,react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from "react";
import "../../styles/filters-form.less";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import { useHistory, useParams } from "react-router-dom";
import moment, { Moment } from "moment";
import {
  displayFormat,
  infinityDateHttpFormat,
  toHttpFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
  toYearMonthDayLineFormat,
} from "../../lib/utils/formatDate";
import { urlFormValidator } from "../../lib/utils/urlFormValidator";
import {
  agreementsSliceActions,
  createAgreement,
  fetchGetAgreementsByAccId,
} from "../../store/slices/agreements";
import { getAccountsVersions } from "../../store/slices/accounts";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";

interface AccountAgreementsPostData {
  fromDate: string;
  toDate: string;
  validFrom: string;
  validTo: string;
  agreementDate: string;
  agreementNumber: string;
  agreementStatusId: number;
  taxMask: number;
}

const AccountAgreementsCreate: FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const dateFormat = displayFormat;
  const accountId = useParams();
  const history = useHistory();
  const [validFromDate, setValidFromDate] = useState<Moment>();
  const [fromDate, setFromDate] = useState<Moment>();
  const [fromDateEvent, setFromDateEvent] = useState<Moment>();
  const [fromDateArray, setFromDateArray] = useState([]);
  const [creatingInProcess, setCreatingInProcess] = useState(false);
  // @ts-ignore
  const accountNumber = accountId?.accountId;

  const { accountsVersions, accountsVersionsLoading } = useSelector(
    (state: RootStateOrAny) => state.accounts
  );
  const { agrStatus, products } = useSelector((state: RootStateOrAny) => state?.rtkDictionaries);

  const { createAgreementLoading } = useSelector((state: RootStateOrAny) => state?.agreements);

  const validateMessages = {
    required: "Обязательно для заполнения",
  };

  useEffect(() => {
    // @ts-ignore
    dispatch(getAccountsVersions({ accountsIds: [accountNumber] }));
  }, []);

  useEffect(() => {
    if (checkIsLoaded(accountsVersionsLoading)) {
      setFromDateArray(accountsVersions[0].map((item) => item.fromDate));
    }
  }, [accountsVersions]);

  const onChangeValidFromDate = (date) => {
    setValidFromDate(date);
  };

  const onChangeDateTo = (date) => {
    const dateTo = moment(date).add(1, "day");
    setFromDate(dateTo);
    setFromDateEvent(date);
  };

  const onFinish = async (values: AccountAgreementsPostData) => {
    setCreatingInProcess(true);
    if (values) {
      values.agreementStatusId = values.agreementStatusId ? values.agreementStatusId : 0;
      values.fromDate = values.fromDate ? toHttpFormatStartOfDay(values.fromDate) : "";
      values.toDate = values.toDate
        ? toHttpFormatEndOfDay(values.toDate)
        : toHttpFormat(infinityDateHttpFormat);
      values.validFrom = toYearMonthDayLineFormat(values.validFrom);
      values.validTo = toYearMonthDayLineFormat(values.validTo);
      values.agreementDate = toYearMonthDayLineFormat(values.agreementDate);
      values.taxMask = 0;
    }
    // @ts-ignore
    await dispatch(createAgreement({ accountId: accountNumber, values }));
  };

  useEffect(() => {
    if (createAgreementLoading === rtkRequestStatusCodes.fulfilled) {
      // @ts-ignore
      dispatch(fetchGetAgreementsByAccId({ accId: accountNumber }));
      dispatch(agreementsSliceActions.resetAgreementsCreateLoading());
      history.push(`/accounts/${accountNumber}/agreements`);
    }
    if (createAgreementLoading === rtkRequestStatusCodes.rejected) {
      setCreatingInProcess(false);
    }
  }, [createAgreementLoading]);

  return (
    <>
      <h1>Создание нового договора</h1>
      <Row>
        <Form
          style={{ width: "100%" }}
          form={form}
          validateMessages={validateMessages}
          name="advanced_search"
          className="create-form"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 6 }}
          onFinish={onFinish}
          labelAlign="left"
        >
          <Form.Item
            label="Номер договора"
            className="create-form__col form-item-required__hidden-error"
            name="agreementNumber"
            rules={[
              {
                required: true,
                message: "",
              },
              {
                pattern: /^.{1,64}$/,
                message: "",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Дата договора"
            className="create-form__col form-item-required__hidden-error"
            name="agreementDate"
            rules={[
              {
                required: true,
                message: "",
              },
            ]}
          >
            <DatePicker format={dateFormat} />
          </Form.Item>

          <Form.Item
            label="Действителен с"
            className="create-form__col form-item-required__hidden-error"
            name="validFrom"
            rules={[
              {
                required: true,
                message: "",
              },
            ]}
          >
            <DatePicker onChange={onChangeValidFromDate} format={dateFormat} />
          </Form.Item>

          <Form.Item
            label="Действителен по"
            className="create-form__col form-item-required__hidden-error"
            name="validTo"
            rules={[
              {
                required: true,
                message: "",
              },
            ]}
          >
            <DatePicker
              disabled={!validFromDate}
              disabledDate={(current) => current < moment(validFromDate)}
              format={dateFormat}
            />
          </Form.Item>

          <Form.Item
            label="Продукт"
            className="create-form__col form-item-required__hidden-error"
            name="productId"
            rules={[
              {
                required: true,
                message: "Пожалуйста, выберите продукт",
              },
            ]}
            initialValue={0}
          >
            <Select>
              {products &&
                products.length !== 0 &&
                products.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Статус"
            className="create-form__col form-item-required__hidden-error"
            rules={[
              {
                required: true,
                message: "",
              },
            ]}
            name="agreementStatusId"
          >
            <Select placeholder="Выберите" style={{ minWidth: "100px" }}>
              {agrStatus &&
                agrStatus.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Дата создания договора"
            rules={[
              {
                required: true,
                message: "",
              },
            ]}
            className="create-form__col form-item-required__hidden-error"
            name="fromDate"
          >
            <DatePicker
              onChange={onChangeDateTo}
              disabledDate={(current) => current < moment(fromDateArray[0])}
              format={dateFormat}
            />
          </Form.Item>

          <Form.Item
            label="Дата окончания версии договора"
            className="create-form__col form-item-required__hidden-error"
            name="toDate"
          >
            <DatePicker
              format={dateFormat}
              disabled={!fromDateEvent}
              disabledDate={(current) => current < moment(fromDate)}
            />
          </Form.Item>

          <Form.Item
            label="Ссылка на договор"
            name="uri"
            rules={[
              {
                // pattern: new RegExp("(www|http:|https:)+[^\\s]+[\\w]"),
                validator: (_, value) => urlFormValidator(value),
                //  required: true,
                message: "Введен недопустимый формат ссылки на договор",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Row
            align="middle"
            style={{ borderTop: "1px solid #CCDDEE", paddingTop: "10px" }}
            justify="center"
          >
            <Col
              span={24}
              style={{
                textAlign: "center",
              }}
            >
              <Button
                style={{
                  margin: "0 8px",
                }}
                onClick={() => {
                  form.resetFields();
                  history.push(`/accounts/${accountNumber}/agreements`);
                }}
              >
                Отмена
              </Button>
              <Button type="primary" htmlType="submit" loading={creatingInProcess}>
                Сохранить
              </Button>
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};

export default AccountAgreementsCreate;
